export const UNIT = 64;
export const TICKS = 30;
export const DRAG = 0.05;
export const TERMINAL_VELOCITY = 5;
export const BOUNCE = 0.05;
export const SHOOT_TIMEOUT = 400;
export const BULLET_LIFETIME = 2000;
